<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { page } from '$app/stores';
  import { trackCtaClick } from '$lib/utils/analytics';
  import { BOOKING_URL, EARLY_ACCESS_URL } from '$lib/links';

  const dispatch = createEventDispatcher();

  export let open = false;

  
  
  
  const links: { href: string; name: string }[] = [
    { href: '/#what-it-does', name: 'What it does' },
    { href: '/#how-it-works', name: 'How it works' },
    { href: '/#red-teaming', name: 'Red-teaming' },
    { href: '/#pricing', name: 'Pricing' },
    { href: '/#faq', name: 'FAQ' },
    { href: '/blog', name: 'Blog' }
  ];

  function handleLinkClick() {
    dispatch('close');
  }

  function handleKeydown(event: KeyboardEvent) {
    if (open && event.key === 'Escape') dispatch('close');
  }
</script>

<svelte:window on:keydown={handleKeydown} />


<div class="mobile-menu-backdrop" class:active={open} on:click={handleLinkClick} aria-hidden="true"></div>

<div class="mobile-menu" class:active={open} aria-hidden={!open} inert={!open}>
  <div class="mobile-menu-inner">
    <div class="mobile-menu-secondary">
      {#each links as l}
        <a
          href={l.href}
          class="mobile-menu-link"
          class:active={$page.url.pathname === l.href}
          on:click={handleLinkClick}
        >
          {l.name}
        </a>
      {/each}
      <a
        href={BOOKING_URL}
        class="mobile-menu-link mobile-menu-phone-only"
        on:click={() => { trackCtaClick('mobile_menu_book', 'Book Now', BOOKING_URL); handleLinkClick(); }}
      >
        Book Now
      </a>
    </div>

    <div class="mobile-menu-cta mobile-menu-phone-only">
      <a href={EARLY_ACCESS_URL} class="btn btn--primary btn--block" on:click={() => { trackCtaClick('mobile_menu_early_access', 'Early Access', EARLY_ACCESS_URL); handleLinkClick(); }}>
        Early Access
      </a>
    </div>
  </div>
</div>

<style>
  
  .mobile-menu {
    position: fixed;
    top: var(--nav-h);
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--bg);
    z-index: 99;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    overflow-y: auto;
  }

  .mobile-menu.active {
    transform: translateX(0);
  }

  .mobile-menu-inner {
    display: flex;
    flex-direction: column;
    padding: 2rem;
    min-height: 100%;
  }

  .mobile-menu-link {
    display: block;
    font-family: var(--font-mono);
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--fg);
    padding: 1.5rem 0;
    border-bottom: 1px solid var(--border);
    transition: color var(--transition), background var(--transition), border-color var(--transition);
  }

  .mobile-menu-link:hover,
  .mobile-menu-link.active {
    color: var(--editorial-muted);
  }

  .mobile-menu-secondary {
    display: contents;
  }

  
  .mobile-menu-secondary .mobile-menu-link:first-child { order: -1; }
  .mobile-menu-backdrop {
    display: none;
  }

  .mobile-menu-cta {
    margin-top: auto;
    padding-top: 2rem;
  }

  
  @media (min-width: 769px) and (max-width: 1024px) {
    .mobile-menu-backdrop {
      display: block;
      position: fixed;
      inset: var(--nav-h) 0 0 0;
      z-index: 98;
      background: rgba(17, 19, 20, 0.28);
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.2s ease;
    }

    .mobile-menu-backdrop.active {
      opacity: 1;
      pointer-events: auto;
    }

    .mobile-menu {
      left: auto;
      right: max(24px, calc((100vw - var(--max-w)) / 2));
      bottom: auto;
      top: calc(var(--nav-h) + 8px);
      width: 380px;
      max-height: calc(100vh - var(--nav-h) - 24px);
      border: 1px solid var(--border);
      box-shadow: 0 24px 60px -20px rgba(17, 19, 20, 0.35);
      transform: translateY(-8px);
      opacity: 0;
      visibility: hidden;
      transition: transform 0.2s ease, opacity 0.2s ease, visibility 0s linear 0.2s;
    }

    .mobile-menu.active {
      transform: translateY(0);
      opacity: 1;
      visibility: visible;
      transition: transform 0.2s ease, opacity 0.2s ease;
    }

    .mobile-menu-inner {
      padding: 12px;
      min-height: 0;
      text-align: left;
    }

    .mobile-menu-secondary {
      display: flex;
      gap: 4px;
      margin-top: 8px;
      padding-top: 8px;
      border-top: 1px solid var(--border-subtle);
    }

    .mobile-menu-secondary .mobile-menu-link {
      flex: 1;
      text-align: center;
      font-size: 0.8rem;
      padding: 10px 8px;
      border: 1px solid transparent;
    }

    .mobile-menu-secondary .mobile-menu-link:hover,
    .mobile-menu-secondary .mobile-menu-link.active {
      background: var(--card-bg);
      border-color: var(--border);
    }

    .mobile-menu-phone-only {
      display: none;
    }
  }

  
  @media (min-width: 1025px) {
    .mobile-menu,
    .mobile-menu-backdrop {
      display: none;
    }
  }
</style>
